import { render, staticRenderFns } from "./ttshop_siterun.vue?vue&type=template&id=47bd4c9b&scoped=true&"
import script from "./ttshop_siterun.vue?vue&type=script&lang=js&"
export * from "./ttshop_siterun.vue?vue&type=script&lang=js&"
import style0 from "./ttshop_siterun.vue?vue&type=style&index=0&id=47bd4c9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bd4c9b",
  null
  
)

export default component.exports